import styled from 'styled-components';

export const StyledTalContentRelatedWrapper = styled.div`
  width: 1180px;
  margin: 0 auto;

  .refresh-demo {
    cursor: pointer;
    color: #017afe;
    font-size: 14px;

    span {
      margin-left: 5px;
    }
  }

  .demo-content {
    height: 178px;
    margin-top: 10px;
    zoom: 1;

    & > div {
      float: left;
      height: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding: 30px;
      background: #fff;
    }

    .demo-input {
      width: 390px;
      border: 1px solid #ddd;
      color: #999;
      font-size: 16px;
      margin-right: 20px;
    }

    .demo-result {
      border: 1px solid #ddd;
      width: 770px;

      & > * {
        display: inline-block;
        float: left;
      }

      .demo-options {
        padding: 0;
        margin: 0;
        width: 400px;
        height: 110px;

        & > li {
          width: 100%;

          & + li {
            margin-top: 20px;
          }

          .btn-normal {
            width: 100%;
            height: 48px;
            line-height: 24px;
            border: 1px solid #ebebeb;
            box-shadow: none;
            box-sizing: border-box;
            min-width: 116px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.1s linear;
            text-decoration: none;
            color: #666;

            display: flex;
            align-items: center;
            justify-content: center;

            &.selected {
              color: #fff !important;
              background-color: #7db6f2;
              border: 1px solid #7db6f2;
            }
          }
        }
      }

      .demo-score {
        width: 288px;
        margin-left: 20px;

        .demo-score-desc {
          font-size: 12px;
          color: #999;
        }

        .demo-score-detail {
          background-color: #ebebeb;
          height: 74px;
          margin-top: 14px;
          line-height: 74px;
          text-align: center;
          font-size: 40px;

          &.good {
            color: #390;
          }

          &.bad {
            color: #c33;
          }
        }
      }
    }
  }
`;
